import { Helmet } from 'react-helmet-async';

// Organization + WebSite JSON-LD, montado una sola vez a nivel de app (no por pagina) --
// le da a Google y a los motores de IA una entidad de marca clara para citar/agrupar,
// algo que el sitio no tenia en absoluto antes de esta auditoria SEO (0 structured data
// en las 8 paginas publicas).
export function SiteSchema() {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'TutorAI Kids',
    url: 'https://tutoraikids.com/',
    logo: 'https://tutoraikids.com/assets/logo.png',
    description:
      'AI-powered learning platform that helps kids with their homework through Socratic-style tutoring, with progress tracking for parents.',
    email: 'support@tutoraikids.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '3007 Rosebud Lane',
      addressLocality: 'Brandon',
      addressRegion: 'FL',
      postalCode: '33511',
      addressCountry: 'US',
    },
    // Solo se listan perfiles reales -- Facebook/Instagram del footer siguen siendo
    // placeholders (href="#"), asi que no van aqui hasta que existan de verdad.
    sameAs: ['https://www.youtube.com/channel/UCXWfrAs3xHXwm3d0VRpE8Tw'],
  };

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TutorAI Kids',
    url: 'https://tutoraikids.com/',
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
    </Helmet>
  );
}
